import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function FetchAssetsbySubmissionService(token,data) {
    return axios.post(`${CURRENT_API_URL}/contentmanagement/get_assets_by_submission`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        // notify.NotifySuccess("Asset note fetched successfully.");
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while fetching assets, please try again later.");
        return false;
    });
}

export default FetchAssetsbySubmissionService;